var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVeloBnb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 32,
    viewBox: "0 0 56 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 16,
    r: 16,
    fill: "#F0B90A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8559 10.0109L35.713 14.1537L33.3024 11.743L39.8559 5.18921L46.4116 11.7452L44.001 14.1558L39.8559 10.0109ZM31.6002 13.4448L29.1895 15.8555L31.6 18.2661L34.0108 15.8554L31.6002 13.4448ZM35.713 17.5581L39.8559 21.7009L44.0009 17.556L46.4128 19.9654L46.4116 19.9667L39.8559 26.5225L33.3022 19.9689L33.2988 19.9655L35.713 17.5581ZM48.1122 13.4461L45.7015 15.8569L48.1121 18.2675L50.5228 15.8567L48.1122 13.4461Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2832 15.9989H42.2842L39.9996 13.7144L38.3112 15.4027H38.3111L38.1171 15.5967L37.7171 15.9969L37.7139 16L37.7171 16.0033L39.9996 18.2858L42.2842 16.0013L42.2853 16L42.2832 15.9989Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#E12E56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9053 16.9228C21.1959 16.9228 19.8106 15.4079 19.8106 13.538C19.8106 11.6687 21.1959 10.1537 22.9053 10.1537C24.6142 10.1537 26 11.6687 26 13.538C26 15.4079 24.6142 16.9234 22.9053 16.9234V16.9228ZM14.7114 23.0121L7.9242 15.7577C6.69193 14.4402 6.69193 12.3046 7.9242 10.9876C8.51003 10.3562 9.31477 10 10.1553 10C10.9958 10 11.8005 10.3562 12.3863 10.9876L19.174 18.2426C20.4063 19.5595 20.4063 21.6957 19.174 23.0121C18.5882 23.6436 17.7833 24 16.9427 24C16.1021 24 15.2972 23.6436 14.7114 23.0121Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeloBnb);
export default __webpack_public_path__ + "static/media/velo-bnb.449e1f8a5ba751efa11d69dfdaf7e2b9.svg";
export { ForwardRef as ReactComponent };